import { ContextMode } from '@components/v2/layout/AppTemplate/appTemplate.types';
import IconButton from '@components/v2/ui/IconButton/IconButton';
import { AppBar, Toolbar } from '@mui/material';
import { ArrowLeft, Menu } from 'lucide-react';
import { type ReactNode } from 'react';
import LangEnum from '../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../modules/translation/TranslationContext';
import { AppTemplateTestIds } from '../../../../../../utils/testIds/appTemplate.testIds';
import { useHeaderStyles } from './header.styles';

interface HeaderProps {
  contextMode?: ContextMode;
  isMobile?: boolean;
  isMenuExpanded?: boolean;
  showMenuToggle?: boolean;
  onMenuToggle: () => void;
  children?: ReactNode;
}

const Header = ({
  contextMode = 'root',
  isMobile = false,
  isMenuExpanded,
  showMenuToggle = true,
  onMenuToggle,
  children,
}: HeaderProps) => {
  const { classes } = useHeaderStyles();
  const { translate } = useTranslation();
  const isBackButton = contextMode === 'nested' && !isMobile;

  return (
    <AppBar className={classes.appBar} color="transparent" elevation={0} position="static">
      <Toolbar className={classes.toolbar} disableGutters>
        {showMenuToggle && (
          <IconButton
            className={classes.shellIconButton}
            icon={isBackButton ? ArrowLeft : Menu}
            size="medium"
            testId={AppTemplateTestIds.MENU_TOGGLE_BUTTON}
            ariaLabel={translate(isBackButton ? LangEnum.GLOBAL_BACK : LangEnum.GLOBAL_MENU)}
            ariaExpanded={isBackButton ? undefined : isMenuExpanded}
            onClick={onMenuToggle}
          />
        )}
        {children}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
